import { __assign, __extends } from "tslib";
import { CancellablePromise } from '@lifaon/observables';
import { HTTP_ROUTE_PRIVATE } from './privates';
import { ConstructHTTPRoute } from './constructor';
import { Route } from '../../core/route/implementation';
import { $super } from '../../misc/instance/snippets';
export function CreateHTTPRouteResolver() {
    return function (options) {
        var instance = this;
        var privates = instance[HTTP_ROUTE_PRIVATE];
        var normalizedOptions = options;
        return CancellablePromise.try(function () {
            return (privates.methods === null)
                || privates.methods.has(normalizedOptions.method);
        }, normalizedOptions)
            .then(function (resolved) {
            return resolved
                && privates.resolve.call(instance, normalizedOptions);
        });
    };
}
var HTTP_ROUTE_RESOLVER = CreateHTTPRouteResolver();
export function HTTPRouteGetMethods(instance) {
    return instance[HTTP_ROUTE_PRIVATE].methods;
}
var HTTPRoute = (function (_super) {
    __extends(HTTPRoute, _super);
    function HTTPRoute(path, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        var _options = __assign(__assign({}, options), { resolve: HTTP_ROUTE_RESOLVER });
        _this = _super.call(this, path, _options) || this;
        ConstructHTTPRoute(_this, path, options);
        return _this;
    }
    Object.defineProperty(HTTPRoute.prototype, "children", {
        get: function () {
            return $super(this, Route).get('children');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HTTPRoute.prototype, "methods", {
        get: function () {
            return HTTPRouteGetMethods(this);
        },
        enumerable: true,
        configurable: true
    });
    HTTPRoute.prototype.resolve = function (options) {
        return _super.prototype.resolve.call(this, options);
    };
    return HTTPRoute;
}(Route));
export { HTTPRoute };
//# sourceMappingURL=implementation.js.map